<template>
    <div class="Step">
        <div
            :class="`Step-flag--${state}`"
            class="Step-flag"
        >
            <div
                v-if="state === 'loading'"
                class="Step-loader"
            />
            <icomoon-icon
                v-if="state === 'completed'"
                name="Check"
                class="Step-label"
            />
            <span
                v-else
                class="Step-label"
                v-text="currentStep ? step : '!'"
            />
        </div>
        <div
            v-if="title"
            :class="{ 'Step-title--todo': state === 'todo' }"
            class="Step-title"
            v-text="title"
        />
    </div>
</template>

<script setup>
import IcomoonIcon from '@/StoreWeb/components/common/IcomoonIcon'
import { computed } from 'vue'

const props = defineProps({
    state: {
        type: String,
        required: true,
        validator: val => ['completed', 'current', 'error', 'loading', 'todo'].includes(val)
    },
    step: {
        type: Number,
        required: true
    },
    title: {
        type: String,
        default: ''
    }
})

const currentStep = computed(() => {
    return ['current', 'loading', 'todo'].includes(props.state)
})
</script>

<style lang="scss" scoped>
@import 'globalScss';

.Step {
    display: flex;
    align-items: center;

    &-label {
        display: block;
    }

    &-flag {
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        width: 28px;
        min-width: 28px;
        height: 28px;
        min-height: 28px;
        border: 2px solid $color-brandPrimary;
        border-radius: 50%;
        background-color: $color-white;
        color: $color-brandPrimary;
        transition: background-color .3s ease-in-out, opacity .3s ease-in-out;

        &--completed {
            border-color: $color-brandPrimary;
            background-color: $color-brandPrimary;
            color: $color-white;
        }

        &--error {
            border-color: $color-warning-bg;
            background-color: $color-warning-bg;
            font-weight: $fontWeight-defaultBold;
            color: $color-warning;
        }

        &--todo {
            .Step-label {
                opacity: .6;
            }

            border-color: rgba($color-brandPrimary, .6);
        }
    }

    &-loader {
        position: absolute;
        top: -3px;
        left: -3px;
        width: calc(100% + 6px);
        height: calc(100% + 6px);
        border-width: 4px;
        border-style: solid;
        border-color: transparent transparent transparent $color-white;
        border-radius: $borderRadius-rounded;
        background-color: transparent;
        animation: rotate 1s infinite linear;
    }

    &-title {
        margin-left: $s2;
        font-size: $font-small;
        font-weight: $fontWeight-defaultBold;
        opacity: 1;
        transition: opacity .3s ease-in-out;

        &--todo {
            opacity: .6;
        }
    }
}

@keyframes rotate {
    from {
        transform: rotate(135deg);
    }

    to {
        transform: rotate(495deg);
    }
}
</style>
